export const SET_BLOCKED_FUNCTIONALITIES_LIST =
  'APP_SET_BLOCKED_FUNCTIONALITIES_LIST';
